export default function AssignmentMarkSummary({ assignmentMarks }) {
  const totalPedingAssignment = assignmentMarks?.reduce(
    (acc, assignmentMark) => {
      if (assignmentMark.status === "pending") {
        acc++;
      }
      return acc;
    },
    0
  );

  const totalAssignmentMarkSent = assignmentMarks?.reduce(
    (acc, assignmentMark) => {
      if (assignmentMark.status === "published") {
        acc++;
      }
      return acc;
    },
    0
  );

  return (
    <ul className="assignment-status">
      <li>
        Total <span>{assignmentMarks?.length}</span>
      </li>
      <li>
        Pending <span>{totalPedingAssignment}</span>
      </li>
      <li>
        Mark Sent <span>{totalAssignmentMarkSent}</span>
      </li>
    </ul>
  );
}
